export default "__VITE_ASSET__bdd70351__"